export const FILE_INTEGRATIONS_QUERY = 'file-integrations';
export const FILE_INTEGRATIONS_HISTORY_QUERY = 'file-integrations-history-query';
export const FILE_INTEGRATIONS_API_URL = process.env.REACT_APP_API_SERVICE_URL;
